<template>
  <basic-container>
    <div class="outer">
      <div class="root" :style="rootStyle" @click="handleClick">
        <img src="./images/title-sygl.png" />
        <div class="list">
          <img src="./images/title-xmxx.png" />
          <div class="table-container">
            <!-- 固定表头 -->
            <table class="table-head">
              <thead>
                <tr>
                  <th v-for="(column, index) in tableColumns" :key="index" :width="column.width">
                    {{ column.title }}
                  </th>
                </tr>
              </thead>
            </table>
            <!-- 滚动的表格内容 -->
            <div ref="scrollContainer" class="scroll-container">
              <table class="table-body" :style="{ marginTop: scrollTop + 'px' }">
                <tbody>
                  <tr
                    v-for="(item, index) in tableData"
                    :key="index"
                    :class="{ 'row-bg': index % 2 }"
                  >
                    <td
                      v-for="(column, colIndex) in tableColumns"
                      :key="colIndex"
                      :width="column.width"
                    >
                      {{ item[column.key] }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="map">
          <div v-for="(marker, index) in markers" :key="index">
            <el-tooltip :content="marker.name" placement="right">
              <div
                class="marker"
                :style="{ left: marker.x, top: marker.y }"
                @click.stop="showDetailDialog($event, marker)"
              ></div>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div v-if="isDetailDialogShow" class="detail-dialog" :style="detailDialogStyle" @click.stop>
        <div class="title">{{ detail.businessName }}</div>
        <div class="img-container">
          <img v-if="detail.fileAttach.length == 0" :src="defaultImg" />
          <el-carousel v-else width="360px" height="230px" arrow="never">
            <el-carousel-item v-for="(img, index) in detail.fileAttach" :key="index">
              <img :src="img.link || defaultImg" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="desc">{{ detail.description }}</div>
      </div>
    </div>
  </basic-container>
</template>
<script>
import * as currApi from '@/api/cockpit/business-management';

export default {
  data() {
    return {
      rootStyle: {},
      defaultImg: require('./images/default-1.png'),
      tableData: [],
      tableContentHeight: 0,
      scrollTop: 0,
      scrollTimer: null,
      tableColumns: [
        { title: '序号', key: 'index', width: '60px' },
        { title: '项目名称', key: 'businessName', width: '240px' },
        { title: '管理面积(m²)', key: 'manageArea', width: '150px' },
        { title: '经营收入(万元)', key: 'operateIncome', width: '150px' },
      ],
      markers: [
        { id: '1897252209788338177', name: '武汉中车四方维保中心', x: '50%', y: '55%' },
        { id: '2011684594255941634', name: '热雪奇迹', x: '52%', y: '56.5%' },
        { id: '1897252372963540993', name: '武商梦时代', x: '55%', y: '58%' },
        { id: '1897252458569285633', name: '武商MALL', x: '45%', y: '53.5%' },
        { id: '1897252545395572738', name: '武商世贸广场', x: '47%', y: '55%' },
        { id: '1897252607441911810', name: '武汉楚河汉街万达广场', x: '55%', y: '55%' },
        { id: '1897252677541314561', name: '武汉经开万达广场', x: '36%', y: '62%' },
        { id: '1897252740959191041', name: '武汉菱角湖万达广场', x: '46.5%', y: '51.5%' },
        { id: '2011697816158617602', name: '范湖万达', x: '48.0%', y: '53.0%' },
        { id: '2011696935295012866', name: '荆州古城万达广场', x: '27.0%', y: '66.0%' },
        { id: '2011698474135863297', name: '黄冈黄州万达', x: '65.0%', y: '53.0%' },
        { id: '2011700462180388865', name: '黄冈武穴万达', x: '67.0%', y: '50.0%' },
      ],
      isDetailDialogShow: false,
      detailDialogStyle: {
        top: '0px',
        left: '0px',
      },
      detail: {},
    };
  },
  created() {
    let scale = (document.body.clientHeight - 162) / 1080;
    this.rootStyle = {
      width: `${2560 * scale}px`,
      height: `${1080 * scale}px`,
    };
    this.getTabelData();
  },
  beforeDestroy() {
    this.stopScroll();
    this.stopCarousel();
  },
  methods: {
    async getTabelData() {
      let { data } = await currApi.getList();
      /* let data = [
        { businessName: '武汉中车四方维保中心', manageArea: '1000', operateIncome: '1000' },
        { businessName: '青王路', manageArea: '2000', operateIncome: '2000' },
        { businessName: '武商梦时代', manageArea: '3000', operateIncome: '3000' },
        { businessName: '武商MALL', manageArea: '4000', operateIncome: '4000' },
        { businessName: '武商世贸广场', manageArea: '5000', operateIncome: '5000' },
        { businessName: '武汉楚河汉街万达广场', manageArea: '6000', operateIncome: '6000' },
        { businessName: '武汉经开万达广场', manageArea: '7000', operateIncome: '7000' },
        { businessName: '武汉菱角湖万达广场', manageArea: '8000', operateIncome: '8000' },
      ]; */
      data.forEach((item, index) => {
        item.index = index + 1;
      });
      this.tableData = [...data];
      // 界面更新后判断内容高度是否超过可视区域，超过则开始滚动
      this.$nextTick(() => {
        const tableBody = this.$refs.scrollContainer;
        const tableBodyHeight = tableBody.clientHeight;
        this.tableContentHeight = tableBody.scrollHeight;
        if (this.tableContentHeight > tableBodyHeight) {
          this.tableData = [...data, ...data]; // 复制一份原始数据，用于做无缝滚动
          this.startScroll();
        }
      });
    },
    startScroll() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
      }
      this.scrollTimer = setInterval(() => {
        this.scrollTop--;
        // 当滚动到复制数据的位置时，重置位置
        if (Math.abs(this.scrollTop) >= this.tableContentHeight) {
          this.scrollTop = 0;
        }
      }, 50);
    },
    stopScroll() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
        this.scrollTimer = null;
      }
    },
    async showDetailDialog(event, item) {
      let { data } = await currApi.getDetail({ id: item.id });
      /* let data = {
        businessName: '天星花园商业街',
        description:
          '天星花园商业街是2000年建成，是中国最长的步行街，南起沿江大道，贯通中山大道、京汉大道，北至解放大道，全长1600米。与地铁2号线、6号线贯通同步，交通便利。天星花园商业街是2000年建成，是中国最长的步行街.',
        fileAttach: [{}, {}],
      }; */
      this.detail = data;
      this.updateDetailDialogPosition(event);
      this.isDetailDialogShow = true;
    },
    updateDetailDialogPosition(event) {
      const offset = 10;
      const targetWidth = 440;
      const targetHeight = 433;
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      let left = event.clientX;
      let top = event.clientY;
      // 默认在右侧，如果显示不下，则改成左侧显示
      if (left + targetWidth + offset > windowWidth) {
        left = left - targetWidth - offset;
      } else {
        left = left + offset;
      }
      if (left < 0) {
        left = 0;
      }
      // 默认在下方，如果显示不下，则改成上方显示
      if (top + targetHeight + offset > windowHeight) {
        top = top - targetHeight - offset;
      } else {
        top = top + offset;
      }
      if (top < 0) {
        top = 0;
      }
      this.detailDialogStyle = {
        top: `${top}px`,
        left: `${left}px`,
      };
    },
    handleClick() {
      this.isDetailDialogShow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
img {
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
}

.outer {
  position: relative;
  width: 100%;
  height: calc(100vh - 162px);
  overflow: hidden;
  background-color: #002a2f;
  display: flex;
  align-items: center;
  justify-content: center;
}

.root {
  position: relative;
  width: 2560px;
  height: 1080px;
  background: url(./images/bg.png);
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;

  .title {
    width: 100%;
  }

  .list {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0 66px 20px;
    box-sizing: border-box;
    width: 50%;

    .table-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      width: 100%;
      color: #ffffff;

      .scroll-container {
        flex: 1;
        overflow: hidden;
        position: relative;
      }

      .table-head {
        th {
          height: 93px;
          text-align: center;
          font-size: 18px;
        }
      }

      .table-body {
        position: absolute;
        width: 100%;
        tr {
          height: 70px;
          text-align: center;
          font-weight: bold;
          font-size: 28px;
        }
        td:nth-child(1),
        td:nth-child(2) {
          font-family: 'YouSheBiaoTiHei';
          font-weight: normal;
          font-size: 24px;
        }
        .row-bg {
          background: url(./images/bg-2.png);
          background-size: 100% 100%;
        }
      }
    }
  }

  .map {
    position: absolute;
    top: 8%;
    right: 0;
    width: 60%;
    height: 90%;
    background-image: url('./images/map-wuhan.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;

    .marker {
      position: absolute;
      top: 49%;
      left: 51%;
      width: 22px;
      height: 22px;
      transform: translate(-50%, -50%);
      background: url('./images/dot.png');
      cursor: pointer;
    }
  }
}

.detail-dialog {
  position: fixed;
  box-sizing: border-box;
  width: 440px;
  height: 433px;
  padding: 0 38px 0 42px;
  background: url('./images/bg-1.png');
  z-index: 10;

  .title {
    font-weight: bold;
    font-size: 22px;
    color: #ffffff;
    padding-top: 6px;
    line-height: 50px;
  }

  .img-container {
    width: 360px;
    height: 230px;
    overflow: hidden;
  }

  .desc {
    margin-top: 10px;
    width: 100%;
    height: 100px;
    font-size: 18px;
    color: #ffffff;
    line-height: 26px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }
}
</style>
